module.exports = "<vb-product-form class=\"form-horizontal\"\r\n                 [control]=\"productForm\">\r\n</vb-product-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/product/edit-product/edit-product.component.html
// module id = ./src/app/store-management/product/edit-product/edit-product.component.html
// module chunks = main